import { createAction, handleActions } from 'redux-actions';
import { pender } from 'redux-pender';
import { fetchStatus } from '../../type/config-status'
import { FETCH_BOX_OPEN_SUCCESS, FETCH_BOX_NOT_OPEN_SUCCESS } from '../../type/ActionTypes'

import * as api from 'lib/api';

// 액션 타입
const GET_BOX = 'box/GET_BOX';
const UPDATE_DONATIONTYPE = 'UPDATE_DONATIONTYPE';
const UPDATE_TAB = 'UPDATE_TAB';

// 액션 생성자
export const getBox = createAction(GET_BOX, api.getBox);
export const updateDonationType = createAction(UPDATE_DONATIONTYPE) 
export const updateTab = createAction(UPDATE_TAB)

// 초기 상태
const initialState =  {
    fetchStatus: "",
    data: {}
};

export default handleActions({
    ...pender({
        type: GET_BOX, 
        onPending : ( state ,  action )  =>  { 
            return { fetchStatus: fetchStatus.Loading };
        } , 
        onSuccess: (state, action) => {
            if(action.payload.type === FETCH_BOX_OPEN_SUCCESS ){
                return { fetchStatus: fetchStatus.OpenSuccess, 
                    payUrl: action.payload.payUrl, 
                    selectTab: action.payload.selectTab, 
                    selectDonationType: action.payload.selectDonationType, 
                    brictoworksGoogleTagManager : action.payload.brictoworksGoogleTagManager,
                    ga4TrackingId : action.payload.ga4TrackingId,
                    googleTagManager : action.payload.googleTagManager,
                    googleAnalytics : action.payload.googleAnalytics,
                    isCrossDomainTrack : action.payload.isCrossDomainTrack,
                    crossDomainTrack : action.payload.crossDomainTrack,
                    data: action.payload.data };
            }else if(action.payload.type === FETCH_BOX_NOT_OPEN_SUCCESS){
                return { fetchStatus: fetchStatus.NotOpenSuccess, isRedirectUrl: action.payload.isRedirectUrl, redirectUrl: action.payload.redirectUrl };
            }else{
                return { fetchStatus : "정의하지 않은 fetch 상태"}
            }
        },
        onFailure : (state ,  action )  =>  { 
            return { fetchStatus: fetchStatus.Fail }
        } 
    }),
    [UPDATE_DONATIONTYPE] : (state, action) => {
        return { ...state, selectDonationType: action.payload };
    },
    [UPDATE_TAB] : (state, action) => {
        return { ...state, selectTab: action.payload };
    },
}, initialState);


// WEBPACK FOOTER //
// ./src/redux/modules/box.js